import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import nl from 'vuetify/es5/locale/nl';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#7CCC93',
        secondary: '#507455',
        accent: '#6DB381',
        // primary: '#1976D2',
        // secondary: '#424242',
        // accent: '#82B1FF',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107',
        // Here we add a custom `tertiary` color
        // tertiary: colors.pink.base,
      },
      light: {
        primary: '#27402E', // dark green
        secondary: '#F77C2F', // orange
        accent: '#7CCC93', // light green
        background: '#e6e6e6', // gray
        dialogBackground: '#FFFFFF', // white
      },
    },
  },
  lang: {
    locales: { nl },
    current: 'nl',
  },
  icons: {
    iconfont: 'fa',
  },
});
